import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Container, Badge } from "react-bootstrap";
import { useAppSelector } from "../../store";
import AppNavbar from "../AppNavbar";
import Sidebar from "./Sidebar";
import OffcanvasMenu from "../OffcanvasMenu";
import Footer from "./Footer";
import LoadingSpinner from "../common/LoadingSpinner";
import BrandLogo from "../common/BrandLogo";
import { FaInfoCircle } from "react-icons/fa";
import MobileLayout from "../../layouts/MobileLayout"; // Added import

const MainLayout: React.FC = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      // Changed to 992px to match SCSS breakpoints
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);

      if (mobile) {
        setSidebarCollapsed(false);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Sidebar handlers
  const handleSidebarToggle = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  if (!isAuthenticated) {
    return (
      <div className="loading-screen">
        <LoadingSpinner text="Redirecting..." />
      </div>
    );
  }

  // Render dedicated Mobile Layout
  if (isMobile) {
    return <MobileLayout />;
  }

  return (
    <div className="layout-wrapper">
      {/* Modern Topbar */}
      <div className="modern-topbar">
        <Container fluid className="px-3">
          <div className="d-flex align-items-center justify-content-between w-100">
            {/* Left: Brand & Tagline */}
            <div className="d-flex align-items-center gap-3">
              <div className="d-flex align-items-center gap-2">
                {/*<BrandLogo height={20} />*/}
                <div className="d-flex flex-column">
                  <span className="topbar-tagline">Agentic AI Platform</span>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <Sidebar
        collapsed={sidebarCollapsed}
        isOpen={true}
        isMobile={false}
        onToggle={handleSidebarToggle}
      />

      {/* Content Area */}
      <div className={`main-content ${sidebarCollapsed ? 'collapsed' : ''}`}>
        {/* Navbar (Replaces Header) */}
        <AppNavbar />

        {/* Main Content */}
        <main className="page-content custom-scrollbar" role="main">
          <div className="content-container animate-fade-in">
            <div className="glass-panel content-wrapper">
              <Outlet />
            </div>
          </div>
        </main>

        {/* Footer */}
        <Footer />
      </div>

      {/* Route Loading Indicator */}
      <div id="route-loading" className="route-loading-bar" />
    </div>
  );
};

export default MainLayout;
